import React from "react"
import types from "prop-types"
import { cloneDeep } from "lodash-es"
import { useSelector } from "react-redux"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { AUTHENTICATED_FORMS_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import { ORGANIZATION_ROLES, READABLE_ROLE_NAMES, SUBMITTER_ROLE } from "utils/userRoleHelpers"
import { Checkbox } from "shared/checkboxes"

const ORDERED_ROLES = cloneDeep(ORGANIZATION_ROLES).reverse()

const UserRoleFilter = ({ onChange, value }) => {
  const subscribedToAuthenticatedForms = useSelector(subscribedToAddOnFeature(AUTHENTICATED_FORMS_FEATURE_NAME))

  const roles = subscribedToAuthenticatedForms
    ? ORDERED_ROLES
    : ORDERED_ROLES.filter((role) => role !== SUBMITTER_ROLE)

  return (
    <div className="flex flex-col gap-2">
      {
        roles.map((role) => (
          <div key={role} className="flex flex-row items-center gap-2">
            <Checkbox
              className="cursor-pointer"
              uuid={`user-role-filter-${role}`}
              value={value[role]}
              onChange={onChange(role)}
            />
            <label htmlFor={`user-role-filter-${role}`} className="cursor-pointer">
              {READABLE_ROLE_NAMES[role]}
            </label>
          </div>
        ))
      }
    </div>
  )
}

UserRoleFilter.propTypes = {
  onChange: types.func.isRequired,
  value: types.shape(ORDERED_ROLES.reduce((shape, role) => {
    shape[role] = types.bool
    return shape
  }, {})).isRequired,
}

export default UserRoleFilter
